import { string } from 'yup';

const alphabetValidation = string()
  .matches(/^[A-Za-z\s]*$/, 'Field can not be numeric or contain special characters')
  .max(25);

export { alphabetValidation }
